export default "__VITE_ASSET__BWKnRM6Z__"